<template>
  <div class="content">
    <div class="container-fluid">
      <card>
        <h4 class="mt-0">Dosya Seç</h4>
        <b-alert show variant="danger" dismissible v-if="errors.length">
          <h4 class="alert-heading my-0 text-center">
            <i class="fas fa-exclamation-triangle"></i> Hata
          </h4>
          <ul class="mb-0">
            <li v-for="e in errors" :key="e.id">
              <b>{{e}}</b> Alanını Doldurmanız gerek
            </li>
          </ul>
        </b-alert>

        <div class="row">
         
          <div class="d-flex justify-content-around w-100 align-items-center">
          <label class="ml-4 btn btn-lg btn-danger mb-0" for="excel">Dosya Seç</label>
          <input type="file" id="excel" v-on:change="uploadExcel($event)" style="display:none">
          <div class="col-12 col-md-1 mb-3 d-flex justify-content-end align-items-start">
            <button class="btn btn-primary btn-fill" v-on:click="checkForm">Kaydet</button>
          </div>
          </div>
        </div>
        <div v-if="content.content" class="row">
          <div class="container">
        <table class="table table-hover table-striped table-bordered mb-0">
        <thead class="thead-dark">
          <th  v-for="(item,index) in content.content.head" :key="index">{{item}}</th>

        </thead>
        <tbody>
          <tr v-for="(item,index) in content.content.values" :key="index">
            <td v-for="(value,key) in item" :key="key">
              {{value}}
            </td>
          </tr>
        </tbody>
         </table>
         </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/UIComponents/Cards/Card.vue';
import Checkbox from 'src/components/UIComponents/Inputs/Checkbox.vue';
export default {
  data: function () {
    return {
      id: this.$route.params.id,
      // post data
      file : null,
      videoupdated: false,
      post: {
        id: null,
        newvideo: null,
        user_id: this.getCurrentUserDetails(),
        category_id: null,
        sub_category_id: null,
        status: 1,
        name: null,
        url: null,
        post_type: 'ActivityProgram',
        image: null,
        content_id: null,
        video_id: null
      },
      errors: [],
      slider: {
        post_id: null,
        order_number: null,
        is_active: 1
      },
      metas: {
        post_id: null,
        items: {
          meta2: {
            meta_key: 'title',
            meta_value: null
          },
          meta3: {
            meta_key: 'description',
            meta_value: null
          }
        }
      },
      tempMetas: null,
      content: {
        content: null
      },
      url: {
        name: null
      },
      showOnSlider: false,
      video: {
        video_url: null
      },
      image: {
        file: null,
        cropped: null
      },
      sliderImage: {
        file: null,
        cropped: null
      },
      croppieType: 'main',
      sliderImageLoaded: false,
      // end of post data
      categories: null,
      subCategories: null,
      users: null,
      options: {
        language_url: '/static/plugins/tinymce-lang/tr.js',
        height: 300
      },
      firstSlider: false
    }
  },
  components: {
    Checkbox,
    Card
  },
  methods: {
    uploadExcel:function(event){
      this.file = event.target.files[0];
      if(this.file.type!==('application/vnd.ms-excel' && 'application/msexcel'  && 'application/x-msexcel' && 'application/x-ms-excel' && 'application/x-excel' && 'application/x-dos_ms_excel' && 'application/xls' && 'application/x-xls' && 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')){
         this.notifier('top', 'right', 'danger', 'Lütfen excel formatında bir dosya seçiniz')
      }else{
        let data = new FormData();
        data.append("file",this.file)
      let fileName = this.file.name.split(".");
      let extension = "";
      let newName = "";
      fileName.forEach((e, index) => {
        if (index < fileName.length - 1) {
          newName += e;
        }
        if (index == fileName.length - 1) {
          extension += e;
        }
      });
      newName += new Date().getTime();
      let fullName = newName + "." + extension;
      this.post.image = fullName;
      data.append("fileName", fullName);
      this.notifier("top","right","warning","Dosya yüklenirken lütfen bekleyiniz.Yüklemeden sonra sayfa yenilenecektir");
      this.$http.post("api/files/upload-excel/"+fullName+'/'+this.post.content.id+'/'+this.id,data).then(
        response=>{
          this.notifier("top","right","success","Excel başarıyla kaydedildi");
          this.$router.go()
        },
        er=>{
          this.notifier("top","right","danger","Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.")
        }
      )
      }
      
    },
    checkForm: function () {
      this.errors = []
      if (!this.post.name) {
        this.errors.push('Başlık')
      }
      if (!this.content.content) {
        this.errors.push('İçerik')
      }
      if (!this.errors.length) {
        this.savePost()
      }
    },
    saveContent: function () {
      var button = event.target
      this.$http
        .post('/api/contents/edit/' + this.post.content.id, this.content)
        .then(
          response => {
           this.notifier('top', 'right', 'success', 'Başarılı')
          this.$router.push('/activity-program')
          },
          e => {
            button.innerHTML = 'Kaydet';
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          }
        )
    },

    savePost: function () {
      this.post.comments = null
      this.post.menus = null
      this.post.slider = null
      this.tempMetas = this.post.post_metas
      this.post.post_metas = null
      this.post.post_tags = null
      this.post.category = null
      this.post.sub_category = null
      this.post.user = null
      this.post.content = null
      if (this.videoupdated) {
        this.post.video = this.video
      } else {
        this.post.video = null
      }

      if (this.metas.items.meta2.meta_value == null) {
        this.metas.items.meta2.meta_value = this.post.name.substring(0, 140)
      }
      if (this.metas.items.meta3.meta_value == null) {
        this.metas.items.meta3.meta_value = this.$sanitize(
          this.content.content,
          { allowedTags: ['br'] }
        ).substring(0, 500)
      }
       this.$http.post('/api/posts/edit/' + this.post.id, this.post).then(
         response => {
            this.saveContent()

         },
         e => {

              if(!e.body.Error){
              this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            }else{
              this.notifier('top', 'right', 'danger', e.body.Error)

            }
         }
       )
    },
    getInitialData: function () {
      this.toggleLoader()
      this.$http.get('/api/posts/get/' + this.id).then(
        response => {
          this.post = response.body
          this.content = this.post.content
          this.content.content = JSON.parse(this.content.content);
         
          console.log(this.post.content.id);
          if (this.post.video) {
            this.video = this.post.video
          } else {
            this.post.video = {
              video_url: null
            }
          }
          if (this.post.slider == null) {
            this.firstSlider = true
          }
          this.toggleLoader()
        },
        er => {
          this.toggleLoader()
          this.notifier(
            'top',
            'right',
            'danger',
            'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
          )
          return;
        }
      )
    },
  },
  mounted: function () {
    this.$nextTick(function() {
this.getInitialData()
    });
    
  }
}
</script>
<style>
.input-group-text.is-valid {
  border-color: #28a745 !important;
}
.input-group-text {
  transition: 300ms;
}
.input-group-text.is-invalid {
  border-color: #dc3545 !important;
  background-color: #dc3545;
  color: #fff;
}
.form-check-label {
  font-size: 16px !important;
  line-height: 15px !important;
  text-transform: capitalize !important;
}
.seo-text {
  background-color: #e9ecef;
  border: 1px solid #ced4da;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PostModules/ActivityProgram/Edit.vue